import { Progress as AntProgress } from "antd"

type Props = {
	progress: number
}

export const Progress = ({ progress }: Props) => {
	return <AntProgress percent={progress} />
}
